module.exports = __webpack_public_path__ + "static/img/icon_guid.a0ec51a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/icon_guid.png
// module id = A8g6
// module chunks = 0